import { render, staticRenderFns } from "./Hdgl.vue?vue&type=template&id=43881e07&scoped=true"
import script from "./Hdgl.vue?vue&type=script&lang=js"
export * from "./Hdgl.vue?vue&type=script&lang=js"
import style0 from "./Hdgl.vue?vue&type=style&index=0&id=43881e07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43881e07",
  null
  
)

export default component.exports